import React from 'react';
import { useState } from 'react';
import { DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { ExpandMore } from '@/components/expand-more/expand-more';

const ConsultRequirements = () => {
	const [expandedDPI, setExpandedDPI] = useState(true);
	const [expandedGA, setExpandedGA] = useState(true);

	return (
		<>
			<DialogHeader>
				<DialogTitle>Consultar certificado</DialogTitle>
			</DialogHeader>
			<p>
				Este servicio también provee información importante sin la
				necesidad de subir el documento. Basta con el ingreso del numero
				de serie del documento o el CA Hash
			</p>
			<ExpandMore
				title="Número de serie"
				body={`El número de serie del certificado puede obtenerse utilizando el servicio de Validar documento o utilizando el lector de pdf de Adobe.`}
				isCollapsed={!expandedDPI}
				toggleExpand={() => setExpandedDPI(!expandedDPI)}
			/>
			<ExpandMore
				title="CA Hash"
				body={`CA Hash es el Certificate authority hash dado al
						documento, este puede obtenerse utilizando el lector de
						pdf de Adobe`}
				isCollapsed={!expandedGA}
				toggleExpand={() => setExpandedGA(!expandedGA)}
			/>
		</>
	);
};

export default ConsultRequirements;
